import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSubCategory, selectSubCategories, selectSubCategory, setSubCategories, selectItems } from '../../slice/itemSlice';
import { Form } from 'react-bootstrap';

const Filter = () => {

  const dispatch = useDispatch();
  
  const subCategories = useSelector(selectSubCategories);

  useEffect(() => {
    dispatch(setSubCategories())
  }, [])

  return (
    <div>
      <Form.Select aria-label="Default select example">
        <option value="">You can also choose a sub-category</option>
        {subCategories && subCategories.map(x => <option key={x} onChange={() => dispatch(setSubCategory(x))} className='text-capitalize fs-5' value={x}>{x}</option>)}
      </Form.Select>
    </div>
  )
}

export default Filter